import React, { Component } from 'react';
import { connect } from 'react-redux';

import RadioGroup, { Radio } from '../../../../../../components/RadioGroup';
import {
  chartViewUnits,
  detailsRanges,
  changeChartIsRelative,
  changeChartViewUnit,
  changeDetailsRange,
} from '../../../../../../redux/dashboard-completed';

import './styles.css';
import { Divider } from 'material-ui';

class DashboardCompletedConfig extends Component {
  _changeViewUnit = (viewUnit) => {
    this.props.dispatch(changeChartViewUnit(viewUnit));
  }

  _changeIsRelative = (isRelative) => {
    this.props.dispatch(changeChartIsRelative(isRelative));
  }

  _changeDetailsRange = (range) => {
    this.props.dispatch(changeDetailsRange(range));
  }

  render() {
    const { chartViewUnit, chartIsRelative, detailsRange } = this.props;

    return (
      <div className="DashboardCompletedConfig__container">
        <div className="DashboardCompletedConfig__content">
          <div className="DashboardCompletedConfig__section">
            <div className="DashboardCompletedConfig__label">Ver números por:</div>
            <RadioGroup
              compact
              value={chartViewUnit}
              onChangeValue={this._changeViewUnit}
            >
              <Radio value={chartViewUnits.QTY} label="Quantidade de NFs" />
              <Radio value={chartViewUnits.WEIGHT} label="Peso transportado" />
              <Radio value={chartViewUnits.VALUE} label="Valor transportado" />
            </RadioGroup>
          </div>
          <Divider />
          <div className="DashboardCompletedConfig__section">
            <div className="DashboardCompletedConfig__label">Valores dos gráficos:</div>
            <RadioGroup
              compact
              value={chartIsRelative}
              onChangeValue={this._changeIsRelative}
            >
              <Radio value={false} label="Absolutos (Quantidade)" />
              <Radio value label="Relativos (Porcentagem)" />
            </RadioGroup>
          </div>
          <Divider />
          <div className="DashboardCompletedConfig__section">
            <div className="DashboardCompletedConfig__label">Detalhamento:</div>
            <RadioGroup
              compact
              value={detailsRange}
              onChangeValue={this._changeDetailsRange}
            >
              <Radio value={detailsRanges.WEEK} label="Semanal" />
              <Radio value={detailsRanges.MONTH} label="Mensal" />
            </RadioGroup>
          </div>
        </div>
      </div>
    );
  }
}

// redux

const mapStateToProps = state => ({
  chartViewUnit: state.dashboardCompleted.chartOptions.viewUnit,
  chartIsRelative: state.dashboardCompleted.chartOptions.isRelative,
  detailsRange: state.dashboardCompleted.details.range,
});

export default connect(mapStateToProps)(DashboardCompletedConfig);
